<template>
  <div
    class="table-wrapper scrollable general-table"
    :class="[name+'-table']"
  >
    <vs-table v-if="listPosts" notSpacer hoverFlat pagination maxItems="20" :data="listPosts" :noDataText="$t('dash.table.no.data')" class="table-content" search>
      <template slot="thead"> 
        <vs-th class="column status" sort-key="status">
          <p>{{$t('dash.table.title.status')}}</p>
          <span class="sort-th">
            <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
              expand_less
            </i>
            <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
              expand_more
            </i>
          </span>
        </vs-th>
        <vs-th class="column time sort" sort-key="published_at">
          <p>{{$t('dash.table.title.time')}}</p>
          <span class="sort-th">
            <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
              expand_less
            </i>
            <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
              expand_more
            </i>
          </span>
        </vs-th>
        <vs-th class="column content sort" sort-key="title">
          <p>{{$t('dash.table.title.content')}}</p>
          <span class="sort-th">
            <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
              expand_less
            </i>
            <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
              expand_more
            </i>
          </span>
        </vs-th>
        <vs-th class="column source" sort-key="flux_name">
          <p>{{$t('dash.table.title.source')}}</p>
          <span class="sort-th">
            <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
              expand_less
            </i>
            <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
              expand_more
            </i>
          </span>
        </vs-th>
        <vs-th class="column both" v-if="filter.includes('all')">
          <p>{{$t('dash.table.title.both')}}</p>
        </vs-th>
        <vs-th class="column both" v-else-if="filter.includes('scheduled') || filter.includes('queue') || filter.includes('failed') || filter.includes('removed')">
          <p>{{$t('dash.table.title.actions')}}</p>
        </vs-th>
        <vs-th class="column both" v-else-if="filter.includes('posted')">
          <p>{{$t('dash.table.title.stats')}}</p>
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <div class="scrollable" v-if="data.length">
        <vs-tr :key="index" v-for="(entry, index) in data"
          class="row"
          :class="[formatStatus(entry), entry.page && entry.page[0] && entry.page[0].story ? 'story' : '']"
          :data="entry"
          :data-qa="formatStatus(entry, true)"
        >
          <div v-if="!entry.page[0] || (entry.page[0] && entry.page[0].status != 0) " class="container" @click="clickPost(gridData.pages, entry)">
            <vs-td :data="formatStatus(entry)" class="column status">
              <div class="page-rs" v-if="entry._bots && ((entry._bots.length && entry._bots[0].page && entry._bots[0].page.name) || (entry._bots.page && entry._bots.page.name))">
                <Tooltip
                  :text="entry._bots[0] ? entry._bots[0].page.name : entry._bots.page.name"
                  position="top"
                >
                  <page-image-avatar :page="entry._bots[0] ? entry._bots[0].page : entry._bots.page"/>
                  &nbsp;
                </Tooltip>
              </div>
              <div :class="formatStatus(entry)">
                <img
                  v-if="formatStatus(entry) === 'draft'"
                  class="status-icon"
                  src="../../assets/img/icon-draft2.png"
                  alt="queue"
                >
                <p v-if="formatStatus(entry) === 'draft'">{{$t('dash.posts.status.draft')}}</p>
                <img
                  v-if="formatStatus(entry) === 'in queue'"
                  class="status-icon"
                  src="../../assets/img/ico-inqueue.svg"
                  alt="queue"
                >
                <p v-if="formatStatus(entry) === 'in queue'">{{$t('dash.posts.status.inqueue')}}</p>
                <img
                  v-if="formatStatus(entry) === 'scheduled'"
                  class="status-icon"
                  src="../../assets/img/ico-scheduled.svg"
                  alt="scheduled"
                >
                <p v-if="formatStatus(entry) === 'scheduled'">{{$t('dash.posts.status.scheduled')}}</p>
                <img
                  v-if="formatStatus(entry) === 'posted'"
                  class="status-icon"
                  src="../../assets/img/ico-check.svg"
                  alt="posted"
                >
                <!-- <p v-if="formatStatus(entry) === 'posted' && entry.page[0].network === 'tiktok'">{{$t('dash.posts.status.uploaded')}}</p>
                <p v-else-if="formatStatus(entry) === 'posted'">{{$t('dash.posts.status.posted')}}</p> -->
                <p v-if="formatStatus(entry) === 'posted'">{{$t('dash.posts.status.posted')}}</p>
                <img
                  v-if="formatStatus(entry) === 'inprogress'"
                  class="status-icon"
                  src="../../assets/img/ico-posting.svg"
                  alt="inprogress"
                >
                <p v-if="formatStatus(entry) === 'inprogress'">{{$t('dash.posts.status.inprogress')}}</p>
                <Tooltip :text="getError(entry)" position="top" v-if="formatStatus(entry) === 'failed'">
                  <img
                    v-if="formatStatus(entry) === 'failed'"
                    class="status-icon"
                    src="../../assets/img/icon_stop.svg"
                    alt="failed"
                  >
                  <p v-if="formatStatus(entry) === 'failed'">{{$t('dash.posts.status.failed')}}</p>
                </Tooltip>
                <img
                  v-if="formatStatus(entry) === 'removed'"
                  class="status-icon"
                  src="../../assets/img/icon_stop.svg"
                  alt="removed"
                >
                <p v-if="formatStatus(entry) === 'removed'">{{$t('dash.posts.status.removed')}}</p>
              </div>
            </vs-td>

            <vs-td :data="formatDate(entry['published_at'])" class="column time">
              <p >{{ formatDate(entry["published_at"]) }}</p>

              <p class="posted-date" v-if="formatStatus(entry) == 'draft' && entry.scheduled_date">
                {{$t('dash.table.date.scheduled')}} {{ formatDate(entry.scheduled_date) }}
              </p>
              <p class="posted-date" v-else-if="entry.page[0] && entry.page[0]['scheduled_date']">
                {{$t('dash.table.date.scheduled')}} {{ formatDate(entry.page[0]["scheduled_date"]) }}
              </p>
              <p class="posted-date" v-else-if="entry.page[0] && entry.page[0]['posted_date'] && ['posted', 'inprogress', 'failed'].includes(formatStatus(entry))">
                {{$t('dash.table.date.posted')}} {{ formatDate(entry.page[0]["posted_date"]) }}
              </p>
            </vs-td>

            <vs-td :data="entry._bots && entry._bots.post_text_layout == 'description' ? entry.description || entry.title : entry.title" class="column content">

              <div v-if="((entry._bots[0] && entry._bots[0].mode === 'story' && entry._bots[0].page && entry._bots[0].page.story_config && entry._bots[0].page.story_config.created) || (entry._bots && entry._bots.mode === 'story' && entry._bots.page && entry._bots.page.story_config && entry._bots.page.story_config.created) ) && !entry.page[0] && entry.enclosure" class="story-img">
                <img :src="entry.enclosure" @error="image403" alt="">
                <img class="template" v-if="(entry._bots[0] && entry._bots[0].storyTemplate && entry._bots[0].storyTemplate.predefined) || (entry._bots && entry._bots.storyTemplate && entry._bots.storyTemplate.predefined)" :src="`https://s3.eu-west-1.amazonaws.com/saas.mashup/static-assets/${entry._bots[0] ? entry._bots[0].storyTemplate.predefined : entry._bots.storyTemplate.predefined}.png`" alt="">
                <p :class="{templatetxt: (entry._bots[0] && entry._bots[0].storyTemplate && entry._bots[0].storyTemplate.predefined) || (entry._bots && entry._bots.storyTemplate && entry._bots.storyTemplate.predefined)}">{{entry.title}}</p>
              </div>
              <div v-else class="thumb-wrapper">
                <video v-if="((entry.page && entry.page[0] && entry.page[0].story) || (entry.draft && entry.draft.type === 'story')) && entry.page && entry.page[0] && entry.page[0].enclosure && entry.page[0].enclosure.slice(-4) === '.mp4'" class="thumb story-video-mini" :src="entry.page[0].enclosure"/>
                <img v-else-if="formatStatus(entry) === 'draft' && (entry.draft.data.form.enclosure || entry.draft.data.multipleImages.length)" class="thumb" :src="entry.draft.data.multipleImages && entry.draft.data.multipleImages.length ? entry.draft.data.multipleImages[0].url : entry.draft.data.form.enclosure" @error="replaceByDefault">
                <img v-else-if="Array.isArray(entry._bots)  && entry._bots.length > 0 && entry._bots[0].mode === 'story' && entry.page[0] && entry.page[0].story" class="story-screenshot testB" :src="JSON.parse(entry.page[0].story).screenshot" @error="replaceByDefault">
                <img v-else-if="entry._bots && entry._bots.mode === 'story' && entry.page[0] && entry.page[0].story" class="story-screenshot testA" :src="JSON.parse(entry.page[0].story).screenshot" @error="replaceByDefault">
                <img v-else-if="entry.enclosure" class="thumb" :src="entry.enclosure" @error="replaceByDefault">
                <img v-else-if="entry.page && entry.page[0] && entry.page[0].enclosure" class="thumb" :src="entry.page[0].enclosure" @error="replaceByDefault">
                <img v-else-if="entry.page && entry.page[0] && entry.page[0].carousel && entry.page[0].carousel.length > 1 && entry.page[0].carousel[0].url" class="thumb" :src="entry.page[0].carousel[0].url" @error="replaceByDefault">
                <video v-else-if="entry.page && entry.page[0] && entry.page[0].video" :src="entry.page[0].video"></video>
                <video v-else-if="formatStatus(entry) === 'draft' && (entry.draft.data.videos && getUrlVideoDraft(entry.draft.data.videos, entry.page[0].network, entry.draft.data.videoReel))" :src="getUrlVideoDraft(entry.draft.data.videos, entry.page[0].network, entry.draft.data.videoReel)"></video>
                <img v-else-if="entry.url && entry.url != ''" class="thumb" :meta="getMetaOgImage(entry, `meta-image-${entry.id}`, index)" :ref="`meta-image-${entry.id}`"  @error="replaceByDefault">
              </div>
              <div class="txt-wrapper">
                <p>
                  <span v-if="entry._bots && entry._bots[0] && entry._bots[0].mode === 'story' && entry.page && entry.page[0] && entry.page[0].enclosure && entry.page[0].enclosure.slice(-4) === '.mp4'">Story video</span>
                  <span v-if="entry.page && entry.page[0] && entry.page[0].is_reshare">[{{$t('dash.post.reshare')}}] {{ entry.page[0].reshare_message }} - </span>  
                  <span v-if="entry.page && entry.page[0] && entry.page[0].is_retweet">[Retweet] </span> 
                  <span class="hin" v-html="getText(entry)"></span>
                </p>
              </div>
            </vs-td>

            <vs-td v-if="entry.flux && entry.flux.source && entry.flux.source.name" :data="entry.flux.source.name" class="column source">
              <p>{{entry.flux.source.name}}</p>
            </vs-td>
            <vs-td v-else-if="sources && sources.find(s => entry.flux && s.uid == entry.flux.id)" :data="sources.find(s => entry.flux && s.uid == entry.flux.id).name" class="column source">
              <p>{{sources.find(s => entry.flux && s.uid == entry.flux.id).name}}</p>
            </vs-td>
            <vs-td v-else data="Custom" class="column source">
            </vs-td>

            <vs-td 
              v-if="['posted', 'failed'].includes(formatStatus(entry)) && entry.page[0] && entry.page[0].network == 'facebook'" 
              :data="entry.page[0].insights ? entry.page[0].insights.find(i => i.name == 'post_impressions').values[0].value : ''" 
              class="column both"
            >
              <ul class="sources" v-if="entry.page[0].insights">
                <li>
                  <img class="icon-white" src="../../assets/img/rss/icon_vues.svg" alt="vues">
                  <p>{{ entry.page[0].insights.find(i => i.name == 'post_impressions').values[0].value }}</p>
                </li>
                <li>
                  <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="likes">
                  <p>{{ entry.page[0].insights.find(i => i.name == 'post_reactions_like_total').values[0].value }}</p>
                </li>
                <li>
                  <img class="icon-white" src="../../assets/img/rss/icon_clicks.svg" alt="clicks">
                  <p>{{ entry.page[0].insights.find(i => i.name == 'post_clicks').values[0].value }}</p>
                </li>
              </ul>
              <vs-button color="#6a1f4c" class="btn-large" v-if="entry.page[0] && entry.page[0].network == 'facebook'" @click="clickPost(gridData.pages, entry)">{{ $t('dash.posts.view' )}}</vs-button>
            </vs-td>
            <vs-td 
              v-else-if="['posted', 'failed'].includes(formatStatus(entry)) && entry.page[0] && entry.page[0].network == 'twitter'" 
              :data="entry.page[0].insights ? entry.page[0].insights.retweet_count : ''" 
              class="column both"
            >
              <ul class="sources" v-if="entry.page[0].insights">
                <li>
                  <img class="icon-white" src="../../assets/img/rss/icon_retweet.svg" alt="vues">
                  <p>{{ entry.page[0].insights.retweet_count }}</p>
                </li>
                <li>
                  <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="likes">
                  <p>{{ entry.page[0].insights.favorite_count }}</p>
                </li>
              </ul>
              <vs-button class="btn-large" color="#6a1f4c" v-if="entry.page[0] && entry.page[0].network == 'twitter'" @click="clickPost(gridData.pages, entry)">{{ $t('dash.posts.view' )}}</vs-button>
            </vs-td>
            <vs-td class="column both" v-else-if="['posted', 'failed', 'removed'].includes(formatStatus(entry))">
              <vs-button class="btn-large" color="#6a1f4c" @click="clickPost(gridData.pages, entry)">{{ $t('dash.posts.view' )}}</vs-button>
            </vs-td>
            <vs-td v-else-if="formatStatus(entry) !== 'posted'" :data="entry._bots && entry._bots.post_text_layout == 'description' ? entry.description : entry.title" class="column both cell">
              <vs-button
                v-if="formatStatus(entry) === 'in queue'"
                :disabled="!canUseCustomSources && (!entry.categorie || !entry.categorie.id)"
                class="btn-large"
                color="#6a1f4c"
                vs-type="filled"
                size="large"
                type="submit"
                @click.prevent="clickPost(gridData.pages, entry)"
              >{{$t(!['Admin', 'Editor', 'Writter'].includes(getUserRole) ? 'dash.posts.view' : 'dash.button.post')}}</vs-button>
              <vs-button
                v-else-if="formatStatus(entry) === 'scheduled'"
                :disabled="!canUseCustomSources && (!entry.categorie || !entry.categorie.id)"
                class="btn-large"
                color="#6a1f4c"
                vs-type="border"
                size="large"
                @click.prevent="clickPost(gridData.pages, entry)"
              >{{$t(!['Admin', 'Editor', 'Writter'].includes(getUserRole) ? 'dash.posts.view' : 'dash.button.edit')}}</vs-button>
              <vs-button
                v-else-if="formatStatus(entry) === 'draft'"
                :disabled="!canUseCustomSources && (!entry.categorie || !entry.categorie.id)"
                class="btn-large"
                color="#6a1f4c"
                vs-type="border"
                size="large"
              >{{$t(!['Admin', 'Editor', 'Writter'].includes(getUserRole) ? 'dash.posts.view' : 'dash.button.edit')}}</vs-button>
            </vs-td>
            <vs-td v-else class="column both"></vs-td>
            <vs-td class="column both">
              <span class="remove-post" v-if="formatStatus(entry) === 'in queue'" @click="excludeNewsFromList(entry)">
                <Tooltip :text="$t('dash.button.exclude.news')" position="top">
                  <i class="vs-icon notranslate icon-scale material-icons" style="background: rgb(255, 255, 255);">close</i>
                </Tooltip>
              </span>
              <span class="remove-post" v-else-if="['scheduled', 'draft', 'posted', 'failed'].includes(formatStatus(entry))" @click="deletePost(entry)">
                <Tooltip :text="$t('dash.button.delete.post')" position="top">
                  <i class="vs-icon notranslate icon-scale material-icons" style="background: rgb(255, 255, 255);">close</i>
                </Tooltip>
              </span>
            </vs-td>
            <template slot="expand">
              <vs-list>
                <vs-list-item class="status" :title="$t('dash.table.title.status')+' :'">
                  <div :class="formatStatus(entry)">
                    <img
                      v-if="formatStatus(entry) === 'in queue'"
                      class="status-icon"
                      src="../../assets/img/icon_wait_grey.svg"
                      alt="queue"
                    >
                    <p v-if="formatStatus(entry) === 'in queue'">{{$t('dash.posts.status.inqueue')}}</p>
                    <img
                      v-if="formatStatus(entry) === 'scheduled'"
                      class="status-icon"
                      src="../../assets/img/icon_time_black.svg"
                      alt="scheduled"
                    >
                    <p v-if="formatStatus(entry) === 'scheduled'">{{$t('dash.posts.status.scheduled')}}</p>
                    <img
                      v-if="formatStatus(entry) === 'posted'"
                      class="status-icon"
                      src="../../assets/img/icon_check_purple.svg"
                      alt="posted"
                    >
                    <!-- <p v-if="formatStatus(entry) === 'posted' && entry.page[0].network === 'tiktok'">{{$t('dash.posts.status.uploaded')}}</p>
                    <p v-else-if="formatStatus(entry) === 'posted'">{{$t('dash.posts.status.posted')}}</p> -->
                    <p v-else>{{$t('dash.posts.status.posted')}}</p>
                     <img
                      v-if="formatStatus(entry) === 'inprogress'"
                      class="status-icon"
                      src="../../assets/img/icon_wait_grey.svg"
                      alt="posted"
                    >
                    <p v-if="formatStatus(entry) === 'inprogress'">{{$t('dash.posts.status.inprogress')}}</p>
                    <img
                      v-if="formatStatus(entry) === 'failed'"
                      class="status-icon"
                      src="../../assets/img/icon_stop.svg"
                      alt="failed"
                    >
                    <p v-if="formatStatus(entry) === 'failed'">{{$t('dash.posts.status.failed')}}</p>
                    <img
                    v-if="formatStatus(entry) === 'removed'"
                    class="status-icon"
                    src="../../assets/img/icon_stop.svg"
                    alt="removed"
                  >
                  <p v-if="formatStatus(entry) === 'removed'">{{$t('dash.posts.status.removed')}}</p>
                  </div>
                </vs-list-item>
                <vs-list-item class="date" :title="$t('dash.table.title.time')+' :'">{{formatDate(entry['published_at'])}}</vs-list-item>
                <vs-list-item class="content" :title="$t('dash.table.title.content')+' :'">
                  <div v-if="((entry._bots[0] && entry._bots[0].mode === 'story' && entry._bots[0].page && entry._bots[0].page.story_config && entry._bots[0].page.story_config.created) || (entry._bots && entry._bots.mode === 'story' && entry._bots.page && entry._bots.page.story_config && entry._bots.page.story_config.created) ) && !entry.page[0] && entry.enclosure" class="story-img">
                    <img :src="entry.enclosure" @error="image403" alt="">
                    <p>{{entry.title}}</p>
                  </div>
                  <div v-else class="thumb-wrapper">
                    <img v-if="Array.isArray(entry._bots) && entry._bots.length > 0 && entry._bots[0].mode === 'story' && entry.screenshot" class="thumb" :src="entry.screenshot" @error="replaceByDefault">
                    <img v-else-if="entry._bots && entry._bots.mode === 'story' && entry.screenshot" class="thumb" :src="entry.screenshot" @error="replaceByDefault">
                    <img v-else-if="entry.enclosure" class="thumb" :src="entry.enclosure" @error="replaceByDefault">
                    <img v-else class="thumb" :meta="getMetaOgImage(entry, `meta-image-${entry.id}`, index)" :ref="`meta-image-${entry.id}`" @error="replaceByDefault">
                  </div>
                  <div class="txt-wrapper">
                    <p v-html="getText(entry)"></p>
                  </div>
                </vs-list-item>
                <vs-list-item class="url" title="URL :">{{entry.url}}</vs-list-item>
                <vs-list-item v-if="entry.flux && entry.flux.source && entry.flux.source.name" :data="entry.flux.source.name" class="sources" :title="$t('dash.table.title.source')+' :'">{{entry.flux.source.name}}</vs-list-item>
                <vs-list-item v-else class="sources" :title="$t('dash.table.title.source')+' :'" :subtitle="'Custom'"></vs-list-item>
                <vs-list-item class="stats" :title="$t('dash.table.title.stats')+' :'" v-if="formatStatus(entry) === 'posted' && entry.page[0] && entry.page[0].network == 'facebook'">
                  <ul class="sources" v-if="entry.page[0].insights">
                    <li>
                      <img class="icon-white" src="../../assets/img/rss/icon_vues.svg" alt="vues">
                      <p>{{ entry.page[0].insights.find(i => i.name == 'post_impressions').values[0].value }}</p>
                    </li>
                    <li>
                      <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="likes">
                      <p>{{ entry.page[0].insights.find(i => i.name == 'post_reactions_like_total').values[0].value }}</p>
                    </li>
                    <li>
                      <img class="icon-white" src="../../assets/img/rss/icon_clicks.svg" alt="clicks">
                      <p>{{ entry.page[0].insights.find(i => i.name == 'post_clicks').values[0].value }}</p>
                    </li>
                  </ul>
                  <vs-button class="btn-large" color="#6a1f4c" v-if="entry.page[0] && entry.page[0].network == 'facebook'" @click="clickPost(gridData.pages, entry)">{{ $t('dash.posts.view' )}}</vs-button>
                </vs-list-item>
                <vs-list-item class="stats" :title="$t('dash.table.title.stats')+' :'" v-else-if="formatStatus(entry) === 'posted' && entry.page[0] && entry.page[0].network == 'twitter'"> 
                  <ul class="sources" v-if="entry.page[0].insights">
                    <li>
                      <img class="icon-white" src="../../assets/img/rss/icon_retweet.svg" alt="vues">
                      <p>{{ entry.page[0].insights.retweet_count }}</p>
                    </li>
                    <li>
                      <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="likes">
                      <p>{{ entry.page[0].insights.favorite_count }}</p>
                    </li>
                  </ul>
                  <vs-button class="btn-large" color="#6a1f4c" v-if="entry.page[0] && entry.page[0].network == 'twitter'" @click="clickPost(gridData.pages, entry)">{{ $t('dash.posts.view' )}}</vs-button>
                </vs-list-item>
                <vs-list-item class="actions" :title="$t('dash.table.title.actions')+' :'" v-else-if="formatStatus(entry) !== 'posted'">
                  <vs-button
                    v-if="formatStatus(entry) === 'in queue'"
                    :disabled="!canUseCustomSources && (!entry.categorie || !entry.categorie.id)"
                    class="btn-large"
                    color="#6a1f4c"
                    vs-type="filled"
                    size="large"
                    type="submit"
                    @click.prevent="clickPost(gridData.pages, entry)"
                  >{{$t(!['Admin', 'Editor', 'Writter'].includes(getUserRole) ? 'dash.posts.view' : 'dash.button.post')}}</vs-button>
                  <vs-button
                    v-else-if="formatStatus(entry) === 'scheduled'"
                    :disabled="!canUseCustomSources && (!entry.categorie || !entry.categorie.id)"
                    class="btn-large"
                    color="#6a1f4c"
                    vs-type="border"
                    size="large"
                    @click.prevent="clickPost(gridData.pages, entry)"
                  >{{$t(!['Admin', 'Editor', 'Writter'].includes(getUserRole) ? 'dash.posts.view' :'dash.button.edit')}}</vs-button>
                </vs-list-item>
                <vs-list-item class="actions" :title="$t('dash.table.title.actions')+' :'" v-else-if="formatStatus(entry) == 'posted'">
                  <vs-button class="btn-large" color="#6a1f4c" @click="clickPost(gridData.pages, entry)">{{ $t('dash.posts.view' )}}</vs-button>
                </vs-list-item>
              </vs-list>
            </template>
          </div>
        </vs-tr>
        </div>
      </template>
    </vs-table>
    <vs-popup :class="`sidebar-action ${version}`" :title="``" :active.sync="showSidebar">
      <component-post-sidebar 
        v-if="gridData.pages && post && post._bots"
        :gridData="gridData" 
        :postOriginal="post"
        :sectionPlanner="false"
        v-on:edit="editPost"
        v-on:deleteScheduled="deleteScheduledEvent"
        v-on:excludeNews="excludeNewsEvent"
        v-on:validate="validatePostEvent"
        v-on:resharePost="resharePost"
        v-on:retweetPost="retweetPost"
        v-on:openLoader="openLoader"
        v-on:validateScheduledPost="validateScheduledPostEvent"
        v-on:removeValidateScheduledPost="removeValidateScheduledPostEvent"
        v-on:addComment="addComment"
        v-on:shareStory="shareToStory"
        v-on:editDraft="editDraft"
        v-on:removeDrafts="removeDrafts"
        v-on:duplicatePost="duplicatePost"
      ></component-post-sidebar>
    </vs-popup>

    <vs-prompt
      color="#6a1f4c"
      @close="removePostsMultiPages = false"
      @cancel="post.status == 'draft' ? removeDraft(post._bots[0].page) : removePost()"
      :cancel-text="$t('dash.posts.multi-pages.remove.prompt.btn-only-one')"
      @accept="post.status == 'draft' ? removeDraft() : deletePostsMultiPages()"
      :accept-text="$t('dash.posts.multi-pages.remove.prompt.btn-all')"
      :title="$t('dash.posts.multi-pages.remove.prompt.title')"
      :active.sync="removePostsMultiPages"
      class="prompt-remove-posts">
        <div class="con-exemple-prompt">
          {{$t('dash.posts.multi-pages.remove.prompt.content')}}          
        </div>
    </vs-prompt>
  </div>
</template>

<script>
import moment from 'moment'
import Popup from '../../utils/Popup'
import Sources from './../mixins/Sources'
import Posts from './../mixins/Posts'
import componentPostSidebar from './PostSidebar.vue'
import PageImageAvatar from './PageImageAvatar.vue'
import Insights from './../mixins/Insights'
import Drafts from './../mixins/Drafts'
import StoryMaker from './StoryMaker.vue'
import imgDefault from '../../assets/img/no-picture.png'
import Tooltip from './tooltip/tooltipInit.vue'

export default {
  name: 'component-customtables',

  mixins: [Insights, Sources, Posts, Drafts],

  components: {
    componentPostSidebar,
    StoryMaker,
    PageImageAvatar,
    Tooltip
  },

  props: {
    gridData: Object,
    columns: Array,
    canUseCustomSources: Boolean,
    page: {
      type: Number,
      required: true
    },
    pages: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    filter: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      version: localStorage.getItem('version_') || 'beta',
      sources: null,

      removePostsMultiPages: false,
      showSidebar: false,
      post: {
        id: null,
        title: null,
        description: null,
        url: null,
        posted_date: null,
        scheduled_date: null,
        preview_date: null,
        date: null,
        status: null, // 0 preview - 1 scheduled - 2 posted
        page: null,
        enclosure: null,
        stats: null,
        _bots: null
      },
    }
  },

  mounted() {
    if(localStorage.sources) this.sources = JSON.parse(localStorage.sources) 
    else this.fetchSources()
  },

  computed: {
    getUserRole() {
      const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
      if(!user) return null
      if(user.admin)
        return 'Admin'
      else
        return user.role && user.role.length
                    ? user.role[0]
                    : 'Editor'
      
    },

    listPosts(){
      if(this.gridData && this.gridData.posts){
        return this.gridData.posts
          .filter(post => this.pages.map(page => page.id).includes((post._bots.length && (post._bots[0].page.id || post._bots[0].page)) || (post._bots.page && post._bots.page.id)))
          .map(post => { 

            return {  ...post,
                      localePubDate: moment(post.published_at).local().format('DD/MM/YY HH:mm'), 
                      flux_name: post.flux && post.flux.source && post.flux.source.name
                                    ? post.flux.source.name
                                    : (this.sources && this.sources.find(s => post.flux && s.uid == post.flux.id) 
                                          ? this.sources.find(s => post.flux && s.uid == post.flux.id).name
                                          : 'Custom')
                    } 
          })
      }
      else
        return []
    }
  },
 
  methods: {

    getUrlVideoDraft(videos, network, reel){
      if(videos && JSON.parse(videos)){
        videos = JSON.parse(videos)
        return  reel && network === 'instagram' ? videos['instagram_reel'] : videos[network]
      }
      return false
    },

    getText(entry, all=false){

      let text = entry._bots && entry._bots.post_text_layout == 'description' ? entry.description || entry.title : entry.title

      if(!text) text = ""

      if(entry.draft){
        //replace multi-mention
        while(text.includes('@[MENTIONS-')){
          let start = text.indexOf('@[MENTIONS-')
          let end = text.indexOf(']', start)
          let index = parseInt(text.substr(start, end+1).replace('@[MENTIONS-', '').replace(']', ''))
          if(entry.draft.data.validMentions[index-1]) {
            let mention = entry.draft.data.validMentions[index-1].find(m => m.network == this.gridData.pages.network)
            if(mention && mention.value) 
              switch(mention.network){
                case 'twitter':
                case 'instagram':
                  mention = mention.value.includes('@[') ? `@${mention.value.substring(2, mention.value.indexOf('('))}` : mention.value
                  break
                case 'facebook':
                case 'linkedin':
                  mention = mention.value.substring(2, mention.value.indexOf('('))
                  break
                default:
              }
            else if(mention && mention.word){
              mention = mention.word
            }
            text = text.substr(0, start) + (mention ? mention : entry.draft.data.validMentions[index-1][0].word) + text.substr(end+1)
          }
          else text = text.substr(0, start) + text.substr(end+1)
        }
      }

      if(!all && text && text.length > 280)
        text = text.substr(0, text.substr(0, 280 - 4).lastIndexOf(" ")) + " ..."
      
      return text
    },

    image403(e) {
      console.log('IMAGE 403');
      e.target.src = "data:image/png;base64,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"
      this.$forceUpdate();
    },

    getMetaOgImage(post, ref, index){
      if(post.url){
        setTimeout(() => {
          if(!post.url.includes('topito.com')){
            this.getNewsMeta(post.url).then(res => {
              const { meta } = res.body
              if(meta && meta.og && meta.og.image){
                if(this.$refs[ref] && this.$refs[ref][0])
                  this.$refs[ref][0].src = meta.og.image
              }
            })
          }
          else if(this.$refs[ref] && this.$refs[ref][0])
            this.$refs[ref][0].src = imgDefault
        }, index*200)
      }
    },

    replaceByDefault(e) {
      e.target.src = imgDefault
    },

    /**
     * Get sources
     */
    fetchSources() {
      let sources
      this.listSources({}).then(res => {
        const { success, sources } = res.body
        if (!success || success !== true) {
          this.dialog.title = 'Error'
          if (!res.body) {
            this.dialog.message = 'Server not responding…'
          } else {
            this.dialog.message = res.body.statusText
          }
          this.dialog.show = true
          return
        }
        localStorage.setItem('sources', JSON.stringify(sources))
        this.sources = sources
      })
    },

    /**
     * Edit actions on click
     * @param {Number} id - posts id to update
     */
    edit(page, id, status) {
      this.$emit('edit', page, id, status)
    },

    formatDate(dateToFormat) {
      let format = moment(dateToFormat)
        .local()
        .format('DD/MM/YY HH:mm')
      return format
    },

    getDate(post){      
      let key = post.page ? Object.keys(post.page)[0] : null

      
      if(post.page && post.page[key] && post.page[key].posted_date) return this.formatDate(post.page[key].posted_date, 'HH:mm')     
      else if(post.page && post.page[key] && post.page[key].scheduled_date) return this.formatDate(post.page[key].scheduled_date, 'HH:mm')
      else if(post.preview_date) return this.formatDate(post.preview_date, 'HH:mm')
      else if(post.status == "slot") return this.formatDate(post.date, 'HH:mm')
      else if(post.status == "draft") return this.formatDate(post.scheduled_date, 'HH:mm')
    },

    formatStatus(entry, isQA=false) {
      let status
      
      if(entry.status == 3 && moment.min(moment(entry.page.find(p => p.status == 3).posted_date), moment(moment().add(-10, 'minutes'))).format() == moment(entry.page.find(p => p.status == 3).posted_date).format()){
        return isQA ? 'table-post-error' : 'failed'
      }

      switch(entry.status){
        case 6: 
          status = isQA ? 'table-post-draft' : 'draft'
          break
        case 5: 
        case 4: 
          status = isQA ? 'table-post-error' : 'failed'
          break
        case 3: 
          status = isQA ? 'table-post-inprogress' : 'inprogress'
          break
        case 2: 
          status = isQA ? 'table-post-posted' : 'posted'
          break
        case 1: 
          status = isQA ? 'table-post-scheduled' : 'scheduled'
          break
        case -1: 
          status = isQA ? 'table-post-removed' : 'removed'
          break
        default:
          status = isQA ? 'table-post-in-queue' : 'in queue'
      }
        
      return status
    },

    getError(entry) {
      let error = entry.page.find(p => [4, 5].includes(p.status))
      return error ? error.post_number : 'Error'
    },

    openTweet(entry){
      const username = entry._bots.find(b => b.uid == entry.page[0].id).page.name
      Popup.open(`https://www.twitter.com/${username}/status/${entry.page[0].post_number}`, '', 900, 700)
    },

    openFacebook(entry) {
      Popup.open(`https://www.facebook.com/${entry.page[0].post_number}`, '', 900, 700)
    },

    toggleSidebar(){
      this.showSidebar = !this.showSidebar
    },
    closeSidebar() {
      this.showSidebar = false
    },

    async validatePostEvent(body){  
      this.closeSidebar()
      this.$emit('validate', body)
    },

    resharePost(pageId, newsId, pageEmbed){
      this.closeSidebar()
      console.log('resharePost', pageId, newsId, pageEmbed)
      this.$emit('resharePost', pageId, newsId, pageEmbed)
    },

    retweetPost(pageId, newsId, pageEmbed){
      this.closeSidebar()
      console.log('retweetPost', pageId, newsId, pageEmbed)
      this.$emit('retweetPost', pageId, newsId, pageEmbed)
    },
    retweetPostOLD(bot, news_id, retweet_id, unretweet=false){
      this.closeSidebar()
      console.log('retweetPost', bot, news_id, retweet_id, unretweet)
      this.$emit('retweetPost', bot, news_id, retweet_id, unretweet)
    },

    editPost(page, id, status, deleteSlot=false, slotDate=null, bot=null){
      this.showSidebar = false
      if(status == "preview") this.$emit('edit', page, id, "inqueue", deleteSlot, slotDate, bot)
      else if(status == "scheduled") this.$emit('edit', page, id, "scheduled")
      else if(status == "failed") this.$emit('edit', page, id, "inqueue")
    },

    duplicatePost(page, post, unique=false){
      this.showSidebar = false
      this.$emit('duplicatePost', page, post, unique)
    },
    
    shareToStory(page, id, media) {
      this.closeSidebar();
      this.$emit('shareStory', page, id, media)
    },

    deleteScheduledEvent(news){
      console.log('deleteScheduledEvent', news)
      this.$emit('deleteScheduled', news)
      this.closeSidebar()
    },

    excludeNewsEvent(bot,post){
      console.log('customTable excludeNewsEvent', bot,post)
      this.$emit('excludeNews', bot, post)
    },

    async excludeNewsFromList(post){
      let confirmDelete = await new Promise((resolve, reject) => {
        this.$vs.dialog({
          type:'confirm',
          color: 'primary',
          title: this.$t('dash.button.exclude.news'),
          text: this.$t('dash.posts.confirm.delete_draft.body'),
          cancelText: this.$t('dash.posts.confirm.delete_draft.btn-cancel'),
          cancel: async () => {        
            resolve(false);
          },
          acceptText: this.$t('dash.posts.confirm.delete_draft.btn-remove'),
          accept: async () => {        
            resolve(true);
          }
        })
      })
      if(confirmDelete) {       
        await this.excludeNewsToPost(post._bots[0].id, post)
        .then(() => {
          this.$emit('excludeNews', post._bots[0], post)
  
          if(this.activeLog){
            let messageLog = ` --- ${post}`
            this.addLog(JSON.parse(localStorage.user), 'exclude-news', messageLog)
          }
        })
      }
    },

    async deletePost(post){

      console.log('deletePost', post)

      if(this.formatStatus(post) == 'draft') {
        if(post.draft.data && post.draft.data.bot && post.draft.data.bot.length > 1){
          this.removePostsMultiPages = true
        }
        else {
          let confirmDelete = await new Promise((resolve, reject) => {
            this.$vs.dialog({
              type:'confirm',
              color: 'primary',
              title: this.$t('dash.posts.confirm.delete_draft.title'),
              text: this.$t('dash.posts.confirm.delete_draft.body'),
              cancelText: this.$t('dash.posts.confirm.delete_draft.btn-cancel'),
              cancel: async () => {        
                resolve(false);
              },
              acceptText: this.$t('dash.posts.confirm.delete_draft.btn-remove'),
              accept: async () => {        
                resolve(true);
              }
            })
          })
          if(confirmDelete)
            this.removeDraft()
        }
      }
      else if(this.formatStatus(post) == 'direct'){
        this.$emit('deleteScheduled', post)
      }
      else {
        let news = this.gridData.posts.find(p => p._id == this.post._id)
        let multipages = this.post.page && this.post.page.length && this.post.page[0].posts_multipages ? this.post.page[0].posts_multipages.reduce((acc, val) => {
          if (!acc.map(e => e.bot).includes(val.bot)) {
            acc.push(val);
          }
          return acc;
        }, []) : []
        console.log("multipages", multipages);
        if(this.post.page && this.post.page.length && this.post.page[0].posts_multipages && this.post.page[0].posts_multipages.length && multipages.length > 1
                && (this.getUserRole == 'Admin' || JSON.parse(localStorage.pages).filter(p => multipages.find(m => m.page == p.id)).length == multipages.length)){
          this.removePostsMultiPages = true
        }
        else {
          let confirmDelete = await new Promise((resolve, reject) => {
            this.$vs.dialog({
              type:'confirm',
              color: 'primary',
              title: this.$t('dash.posts.confirm.delete_post.title'),
              text: this.$t('dash.posts.confirm.delete_post.body'),
              cancelText: this.$t('dash.posts.confirm.delete_post.btn-cancel'),
              cancel: async () => {        
                resolve(false);
              },
              acceptText: this.$t('dash.posts.confirm.delete_post.btn-remove'),
              accept: async () => {        
                resolve(true);
              }
            })
          })
          if(confirmDelete)
            this.removePost(news)
        }
      }
    },

    removeDraft(page=null){
      console.log('removeDraft', this.post.id, page)
      this.deleteDraft(this.post.id, page)
      // this.$emit('removeDrafts', this.post.id)
      this.removeDrafts(this.post.id)
    },

    removePost(news){
      this.removePostsMultiPages = false
      if(!news)
        news = this.gridData.posts.find(p => p._id == this.post._id)
      let current_story = this.post.page && this.post.page.length && this.post.page[0].posts_multipages ? this.post.page[0].posts_multipages.find(e => e._id === news.id && e.story) : null
      let multistory = current_story && this.post.page[0].posts_multipages ? this.post.page[0].posts_multipages.filter(e => {
        return e.bot === current_story.bot && e.story
      }) : []
      console.log(multistory, current_story, news);
      if (multistory.length > 1) {
        multistory.forEach(p => {
          news._id = p._id
          news.id = p._id
          if(news._bots && news._bots[0] && news._bots[0].id)
            news._bots[0].id = p.bot
          else
            news._bots.id = p.bot
          news.page[0].post_number = p.postId
          news.page[0].status = p.status
          this.$emit('deleteScheduled', news)
        })
      } else {
        this.$emit('deleteScheduled', news)
      }
    },

    deletePostsMultiPages(){
      this.removePostsMultiPages = false
      if(this.post.page[0].posts_multipages && this.post.page[0].posts_multipages.length){
        let news = this.gridData.posts.find(p => p._id == this.post._id)
        this.post.page[0].posts_multipages.forEach(p => {
          news._id = p._id
          news.id = p._id
          if(news._bots && news._bots[0] && news._bots[0].id)
            news._bots[0].id = p.bot
          else
            news._bots.id = p.bot
          news.page[0].post_number = p.postId
          news.page[0].status = p.status
          this.$emit('deleteScheduled', news)
        })
      }
    },

    /**
     * actions on click post
     * @param {Number} id - posts id to update
     */
    clickPost(page, post) {
      console.log('p', post)
      
      this.showSidebar = true

      if(this.formatStatus(post) === 'draft') {
        this.post.id = post.id || null
        this.post._id = post.id || null
        this.post.title = this.getText(post, true) || null
        this.post.description = post.description || null
        this.post.url = post.url || null
        this.post.posted_date = post.status == 'posted' ? post.page[0].posted_date : null
        this.post.scheduled_date = post.status == 'scheduled' || post.status == 'failed' ? post.page[0].scheduled_date : null
        this.post.preview_date = post.status == 'preview' ? post.preview_date : null
        this.post.date = post.status == 'slot' ? post.date : null
        this.post.status = this.formatStatus(post)
        this.post.page = post.page || null   

        this.post._bots = post._bots || null
        this.post.flux = post.flux || null
        this.post.typePost = post.draft.data.typePost
        this.post.screenshot = post.draft.data.screenshot
        this.post.videoReel = post.draft.data.videoReel
        this.post.videos = post.draft.data.videos ? JSON.parse(post.draft.data.videos) : []
        this.post.location = post.draft.data.location ? JSON.parse(post.draft.data.location) : null
        this.post.data = post.draft.data
      }
      else {
        this.post.id = post.id || post._id
        this.post._id = post._id || post._id
        this.post.title = post.title || null
        this.post.description = post.description || null
        this.post.enclosure = post.enclosure || null
        this.post.url = post.url || null
        if(post.page && post.page[0]) {
          this.post.posted_date = post.page[0].status == 2 ? post.page[0].posted_date : null
          this.post.scheduled_date = post.page[0].status == 1  ? post.page[0].scheduled_date : null
        }
        this.post.preview_date = null
        this.post.date = null
        if(post.page && post.page[0])
          this.post.status = this.formatStatus(post)
        else 
          this.post.status = 'preview'
          
        this.post.page = post.page || null   
        this.post._bots = Array.isArray(post._bots) ? post._bots : [post._bots] || null
        this.post.flux = post.flux || null
  
        this.processInsights(post, this.page)
      }
    },

    editDraft(post) {
      // post = this.gridData.posts.find(p => p.id == post.id)
      this.$emit('editDraft', post.draft)
      this.showSidebar = false
    },

    removeDrafts(postId){
      this.$emit('removeDrafts', postId)
      this.closeSidebar()
    },
    
    openLoader(bool){
      this.$emit('openLoader', bool)
    },

    processInsights(post, index) {
      if(post.page && post.page.length > 0 &&
        (
          post.page[0].status == 2 ||
          (post.page[0].status == 1 && new Date(post.page[0].scheduled_date).getTime() <= new Date().getTime())
        )
      ){
        this.getInsights([post]).then(res => {          
          this.post.stats = res.body.posts[0].page[0].insights || null  
        })
      }
    },
    
    async validateScheduledPostEvent(body, all=false){  
      console.log('validatePost', body)
      const user = JSON.parse(localStorage.user)
      await this.validateWaitingPost(body, {
        name: `${user.firstname} ${user.lastname}`, 
        email: user.email,
        date: moment().format()
      }, all)
      .then(() => {
        setTimeout(() => {this.$emit('reload')}, 500)
      })
      .then(this.closeSidebar)
    },

    async removeValidateScheduledPostEvent(body) {
      console.log('removeValidation', body)
      const user = JSON.parse(localStorage.user)
      await this.removeValidateWaitingPost(body)
      .then(() => {
        setTimeout(() => {this.$emit('reload')}, 500)
      })
      .then(this.closeSidebar)
    },

    async addComment(post, message, mediasUpload, all=false) {
      console.log('addComment', post, message, all)
      const user = !localStorage.supervisor ? JSON.parse(localStorage.user)
                                            : {
                                              firstname: 'Mashup Web',
                                              lastname: 'Social',
                                              email: 'contact@mashup-web.com'
                                            }

      await this.addCommentPost(post, {
        name: `${user.firstname} ${user.lastname}`, 
        email: user.email,
        date: moment().format(),
        message,
        mediasUpload}, all)
      .then(() => {
        setTimeout(() => {this.$emit('reload')}, 500)
      })
      .then(this.closeSidebar)
    },
  },

  watch: {
    gridData: {
      handler(val, oldVal){
        this.closeSidebar()
      },
      deep: true
    },

    showSidebar() {
      if(!this.showSidebar)
        this.post = {
          id: null,
          title: null,
          url: null,
          posted_date: null,
          scheduled_date: null,
          preview_date: null,
          date: null,
          status: null, // 0 preview - 1 scheduled - 2 posted
          page: null,
          enclosure: null,
          stats: null
        }
        this.$store.dispatch('resetStorification'); 
    }
  }
}
</script>